import React = require("react");
import { ITeam } from "Agile/Scripts/Models/Team";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { BaseButton } from "OfficeFabric/Button";
import { TeamPickerCallout } from "./TeamPickerCallout";

interface ITeamPickerProps {
    projectId: string;
    selectedTeam: ITeam;
    onTeamSelected: (team: ITeam) => void;
}

export const TeamPicker = (props: ITeamPickerProps) => {
    const CSS_Change_Parent_Dialog_Team_Header_Button_Container = "change-parent-dialog-team-header-button-container";

    const [isTeamCalloutOpen, setIsTeamCalloutOpen] = React.useState(false);

    const render = (): JSX.Element => {
        const { projectId, selectedTeam } = props;

        return (
            <>
                <div className={CSS_Change_Parent_Dialog_Team_Header_Button_Container}>
                    <BaseButton
                        className="change-parent-dialog-team-header-button"
                        onClick={_showTeamCallout}
                        aria-haspopup={true}
                        aria-expanded={isTeamCalloutOpen}
                    >
                        {selectedTeam.name} <VssIcon iconType={VssIconType.fabric} iconName={"ChevronDown"} />
                    </BaseButton>
                </div>
                {isTeamCalloutOpen && (
                    <TeamPickerCallout
                        projectId={projectId}
                        calloutTargetQuerySelector={`.${CSS_Change_Parent_Dialog_Team_Header_Button_Container}`}
                        selectedTeam={selectedTeam}
                        onDismiss={_hideTeamCallout}
                        onSelection={_onTeamSelected}
                    />
                )}
            </>
        );
    };

    const _onTeamSelected = (team: ITeam): void => {
        _hideTeamCallout();
        props.onTeamSelected(team);
    };

    const _showTeamCallout = (): void => {
        if (!isTeamCalloutOpen) {
            setIsTeamCalloutOpen(true);
        }
    };

    const _hideTeamCallout = (): void => {
        if (isTeamCalloutOpen) {
            setIsTeamCalloutOpen(false);
        }
    };

    return render();
};
